import { useMemo } from 'react';

import { useLoginOrSignupPageData } from 'src/app/pages/loginOrSignup/pageContext';

type Network = 'facebook' | 'google';

type Result = ModelHookResult<{
	buttons: readonly Network[];
}>;

export function useLoginSocialButtons(): Result {
	const {
		data: {
			featureConfigs: { googleAuthEnabled },
		},
	} = useLoginOrSignupPageData();

	return {
		data: {
			buttons: useMemo(() => {
				const buttons: Network[] = [];
				if (googleAuthEnabled) buttons.push('google');
				buttons.push('facebook');
				return buttons;
			}, [googleAuthEnabled]),
		},
	};
}
